/* eslint-disable max-lines */

import { ResponsiveSankey } from '@nivo/sankey';
import withWidget from 'decorators/widget';
import WidgetLoading from 'decorators/widget/WidgetLoading';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { DefaultWidgetComponentProps, MetricsDataV2 } from 'types';
import makeCustomSankey from './makeCustomSankey';

/* const ToolTip = ({
  datum,
  coords,
}: {
  datum: TooltipProps<HeatMapDatum>;
  coords: Coords | null;
}): JSX.Element => {
  const portal = document.getElementById('tooltip-portal');

  const ttip = (
    <div
      data-testid="tooltip-text"
      style={{
        left: (coords?.left || 0) + 20,
        top: (coords?.top || 0) - 10,
        zIndex: 1000,
      }}
      className=" bg-litlingo-off-white p-1 rounded flex items-center shadow-md fixed"
    >
      <div
        style={{
          background: datum.cell.color,
        }}
        className="h-3 w-3 mr-2"
      />
      <span className="text">
        <b>{datum.cell.serieId}</b> - {datum.cell.data.x}: <b>{datum.cell.formattedValue}</b>
      </span>
    </div>
  );

  if (portal) {
    return ReactDOM.createPortal(ttip, portal);
  }
  return <></>;
}; */

// FIXME: Change DefaultWidgetComponentProps to use new metrics type
// once the migration to the new structure is done
const EscalationPathWidget: React.FC<
  DefaultWidgetComponentProps & { widgetData: MetricsDataV2 } & RouteComponentProps<{
      [paramName: string]: string | undefined;
    }>
> = (props) => {
  const { nivoProps, isExpandedView } = props;

  // const history = useHistory();
  // const dispatch = useDispatch();
  // const user = useSelector(getUser);
  // const policy = useSelector(getPermissionsPolicy);
  // const customerDomain = useSelector(getCustomerDomain);
  // const widgetFilters = useSelector(getNavWidgetFilters(widgetId));

  // const filters = useSelector(getNavParamsByResource(resourceQueryParamName.metrics));
  // const range = useTimeRange();

  const processedData = {
    data: {
      nodes: [
        {
          id: 'Pending',
          nodeColor: '#D6D6D6',
        },
        {
          id: 'Escalate',
          nodeColor: '#D6D6D6',
        },
        {
          id: 'Escalate 1',
          nodeColor: '#D6D6D6',
        },
        {
          id: 'Reviewer Follow-up',
          nodeColor: '#D6D6D6',
        },
        {
          id: 'Legal Follow-up',
          nodeColor: '#D6D6D6',
        },
        {
          id: 'Acceptable',
          nodeColor: '#D6D6D6',
        },
        {
          id: 'Follow-up Complete',
          nodeColor: '#D6D6D6',
        },
      ],
      links: [
        {
          source: 'Pending',
          target: 'Acceptable',
          value: 100,
        },
        {
          source: 'Pending',
          target: 'Escalate',
          value: 50,
        },
        {
          source: 'Escalate',
          target: 'Acceptable',
          value: 40,
        },
        {
          source: 'Escalate',
          target: 'Escalate 1',
          value: 10,
        },

        {
          source: 'Pending',
          target: 'Escalate 1',
          value: 20,
        },

        {
          source: 'Escalate 1',
          target: 'Acceptable',
          value: 5,
        },
        {
          source: 'Escalate 1',
          target: 'Reviewer Follow-up',
          value: 10,
        },
        {
          source: 'Escalate 1',
          target: 'Legal Follow-up',
          value: 15,
        },

        {
          source: 'Reviewer Follow-up',
          target: 'Follow-up Complete',
          value: 10,
        },
        {
          source: 'Legal Follow-up',
          target: 'Follow-up Complete',
          value: 15,
        },
      ],
    },
  };

  if (!processedData) {
    return <WidgetLoading />;
  }

  /* const handleClick = (datum: ComputedDatum<BarDatum>): void => {
    // this widget only ever has a single metric config
    // so we pluck the first query config
    const [id, type] = widgetId.split('--');
    logEvent(`Dashboard-click-${id}-${type}`);

    const query = queryData.queries[0];
    if (query == null) {
      return;
    }

    const info = metricsLinksMap[query.metric];
    if (info == null || !isActionAuthorized(info.action, user.roles, policy)) {
      return;
    }

    const series = widgetData.results[0];

    if (series == null) {
      return;
    }

    const start = Number(
      Date.parse(
        series.x_axis[datum.index].value.slice(-1) === 'Z' ||
          series.x_axis[datum.index].value[series.x_axis[datum.index].value.length - 6] === '-' ||
          series.x_axis[datum.index].value[series.x_axis[datum.index].value.length - 6] === '+'
          ? series.x_axis[datum.index].value
          : series.x_axis[datum.index].value.concat('Z')
      )
    );
    const end =
      range.created_before && datum.index + 1 === series.x_axis.length
        ? Number(Date.parse(range.created_before))
        : Number(
            Date.parse(
              series.x_axis[datum.index + 1].value.slice(-1) === 'Z' ||
                series.x_axis[datum.index + 1].value[
                  series.x_axis[datum.index + 1].value.length - 6
                ] === '-' ||
                series.x_axis[datum.index + 1].value[
                  series.x_axis[datum.index + 1].value.length - 6
                ] === '+'
                ? series.x_axis[datum.index + 1].value
                : series.x_axis[datum.index + 1].value.concat('Z')
            )
          );
    const dimensions: Record<string, string | string[]> = {};

    if (info.dimensions != null) {
      Object.entries(info.dimensions).forEach(([dimension, param]) => {
        const allowed = allowedReadOnlyDimensions[query.metric];
        // if allowedDimension is not defined or the dimension is not included,
        // just ignore it
        if (allowed == null || !allowed.includes(dimension)) {
          return;
        }

        let value: string | string[] = '';
        if (filters[dimension] != null) {
          const topValue = filters[dimension];
          value = topValue; // topValue
        }

        if (widgetFilters[dimension] != null) {
          const widgetValue = widgetFilters[dimension];
          value = widgetValue; // widgetValue
        }

        if (query.group_by === dimension || query.group_by?.includes(dimension)) {
          value = datum.id as string;
        }

        dimensions[`${info.resource}__${param}`] = value;
      });
    }

    let groupBy: string;
    let isReviewedReviewValue = false;
    if (Array.isArray(query.group_by)) {
      // eslint-disable-next-line prefer-destructuring
      groupBy = query.group_by[0];
      isReviewedReviewValue = query.group_by.some((item) => item === 'is_reviewed_review_value');
    } else {
      groupBy = query.group_by ?? '';
      isReviewedReviewValue = groupBy === 'is_reviewed_review_value';
    }
    const datumId = datum.id as string;
    const datumIdData: Record<string, string | string[]> = {};

    if (datumId === 'reviewed') {
      datumIdData[`${info.resource}__review_values`] = ['in_policy', 'out_of_policy'];
    } else if (isReviewedReviewValue && datumId === 'pending') {
      datumIdData[`${info.resource}__review_values`] = ['pending', 'skipped'];
    }

    const startValue = moment.utc(start).format(FULL_DATE_FORMAT);
    const endValue = moment.utc(end).format(FULL_DATE_FORMAT);

    const tree = getValuesFromDimensions({ ...dimensions, ...datumIdData });
    const newTree = setNewValue(tree, 'date_range', `${startValue}<>${endValue}`, '', true);

    dispatch(
      requestTreeFiltersToogle({
        value: true,
      })
    );
    dispatch(clearTree());
    history.pushLookup({
      customerDomain,
      routeName: info.route,
      queryParams: {
        [`${info.resource}__filters_search`]: transformToString(newTree),
        [`${info.resource}__has_events`]: ['true'],
        ...dimensions,
        ...datumIdData,
      },
    });
  }; */

  const { ...nivoArgs } = nivoProps || {};

  const renderChart = (): JSX.Element => (
    <>
      <div className={`h-full chart-svg-overflow ${isExpandedView ? '' : ''}`}>
        <ResponsiveSankey
          data={processedData.data}
          margin={{ bottom: 40 }}
          align="justify"
          // colors={(node): string => node.nodeColor}
          nodeOpacity={1}
          nodeHoverOthersOpacity={0.35}
          nodeThickness={25}
          nodeBorderWidth={0}
          nodeBorderColor={{ from: 'color', modifiers: [['darker', 0.8]] }}
          nodeBorderRadius={3}
          linkOpacity={0.5}
          linkHoverOthersOpacity={0.1}
          linkContract={10}
          labelPosition="outside"
          labelOrientation="vertical"
          labelPadding={0}
          labelTextColor="black"
          sort="input"
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...nivoArgs}
          layers={[makeCustomSankey()]}
        />
      </div>
    </>
  );

  return (
    <div className={`flex flex-col h-full ${!isExpandedView && 'overflow-visible'}`}>
      <div className="-mt-3 text-small">
        <span>Messages</span>
      </div>
      {renderChart()}
    </div>
  );
};

export default withWidget({
  title: 'Events',
  subtitle: '',
  allowDownload: true,
  reRenderWhitGrouping: true,
})(EscalationPathWidget as unknown as React.FC<DefaultWidgetComponentProps>);
// FIXME: Remove this cast when the migration to the new structure is done
